// Tabs/TabPanelContent.toxicity.tsx
import React from 'react';
import MutagenicityTableCard from '../components/tabs/toxicity/MutagenicityTable';
import PubChemTableCard from '../components/tabs/compounds/PubchemTable';
import ToxicantsDiseasesTableCard from '../components/tabs/toxicity/ToxicantsDiseaseTable';
import MutagenicityCard from '../components/tabs/toxicity/Mutagenicity';
import ToxicantsDiseasesCard from '../components/tabs/toxicity/ToxicantsDisease';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentToxicity: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <MutagenicityTableCard header={'Mutagenicities'} eventGroupToTrigger={'toxicity'} />
            <PubChemTableCard header={'PUBCHEM - Toxicity'} storageValue={'toxicity'} eventGroupToTrigger={'toxicity'} />
            <ToxicantsDiseasesTableCard header={'Toxicants Disease List'} eventGroupToTrigger={'toxicity'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="toxicity" />
        </div>
        <div className="col-3 col-sm-3">
            <MutagenicityCard header={'In Silico Mutagenicity'} eventGroupToTrigger={'toxicity'} />
            <ToxicantsDiseasesCard header={'Toxicant Disease'} eventGroupToTrigger={'toxicity'} />
        </div>
    </div>
);

export default TabPanelContentToxicity;
